<mapfre-header [isGuest]="true" [guestTitle]="'Save Payment'"></mapfre-header>
<div class="container mapfre-content guest-payment-widget-container">
  <mapfre-card [singleCard]="false" additionalClasses="guest-payment-widget" additionalSectionClasses="align-top">
    <div [ngClass]="{'shows': !loading, 'hides': loading}">
      <div id="portalOneContainer" class="portalOneContainer"></div>
    </div>
    <div [ngClass]="{'shows': loading, 'hides': !loading}">
      <mapfre-loading></mapfre-loading>
    </div>
  </mapfre-card>
</div>
